import { createTheme } from '@mui/material/styles';
import teal from '@mui/material/colors/teal';
import amber from '@mui/material/colors/amber';

export const baseTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: teal,
      secondary: amber,
    },
    components: {
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            position: 'absolute',
            bottom: '-18px',
            right: 0,
            textAlign: 'right',
            whiteSpace: 'nowrap',
          },
        },
      },
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            fontSize: '24px',
            width: '24px'
          }
        }
      }
    },
  });

export const materialThemeScriptSingle = createTheme({
    palette: {
        mode: 'light',
        primary: teal,
        secondary: amber,
    },
});